export default "__VITE_ASSET__DcUpwnH8__"